import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import DetectTouch from '~utilities/detect-touch';

const JS_SCROLL = 'js-scroll';

class Scroll {
  constructor(element) {
    this.element = element;

    if(!DetectTouch.hasTouch) {
      gsap.registerPlugin(ScrollTrigger);
      this.options();
    }
  }

  standardAnimations() {
    var action = gsap.timeline()

    const scrollElements = [...this.element.querySelectorAll('[js-scroll-element]')];

    scrollElements.forEach((scrollElement, index) => {
      const scrollChildren = [...scrollElement.querySelectorAll('[js-scroll-child]')];

      action.from(scrollElement, {
        scrollTrigger: this.scrollOptions(scrollElement),
        duration:1,
        opacity: 0,
        y:'120px',
        clearProps: "transform"
      });

      if(scrollChildren.length) {
        scrollChildren.forEach((scrollChild, index) => {
          const delay = index * 30;

          action.from(scrollChild, {
            scrollTrigger: this.scrollOptions(scrollElement, delay),
            duration: 1,
            y:`${delay}px`,
            clearProps: "transform"
          });
        });
      }
    });
  }

  scrollOptions(element) {
    const scroller = document.documentElement.querySelector('c-content');

    return {
      scroller: scroller,
      trigger: element,
      start: "top 100%",
      end: "top 60%",
      scrub: true
    }
  }
  
  options() {
    let attributes = this.element.getAttribute(JS_SCROLL);
    if(!attributes) return;
    attributes = attributes.split('|');
    
    attributes.forEach(attribute => {
      switch(attribute) {
        case 'standard':
          var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          if(!isSafari) {
            this.standardAnimations();
          }
          break;
        default:
          console.warn(`scroll.options(): ${attribute} is not an option.`);
          break;
      }
    });
  }
}

export default Scroll;